import templateUrl from 'emun.order/ticket-order.htm'
import controller from 'emun.order/ticket-order.controller'

export default {
    bindings: {
		orderId: '@'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};